import React from "react";
import { HStack, Text } from "@chakra-ui/react";
import { UseCase } from "../lib/types";

type BusinessEntityUseCaseTagProps = {
  type: UseCase;
  variant: "contractor" | "client";
  tagsWidth?: "full" | "auto";
};

type BusinessEntityUseCaseTagsProps = {
  useCase: UseCase;
  tagsWidth?: "full" | "auto";
};

const BusinessEntityUseCaseTag = ({
  variant,
  tagsWidth = "full",
}: BusinessEntityUseCaseTagProps) => {
  const tagConfig = {
    contractor: {
      color: "#00468C",
      bgColor: "#D7E7F7",
      text: "受注したい",
    },
    client: {
      color: "#246C03",
      bgColor: "#E0E8DC",
      text: "発注したい",
    },
  };

  const config = tagConfig[variant];

  return (
    <HStack
      color={config.color}
      bgColor={config.bgColor}
      py={0.5}
      px={3}
      borderRadius="full"
      w={tagsWidth}
      justify={"center"}
    >
      <Text fontSize={{ base: "xs", md: "sm" }} mt="1px">
        {config.text}
      </Text>
    </HStack>
  );
};

const BusinessEntityUseCaseTags = ({
  useCase,
  tagsWidth = "full",
}: BusinessEntityUseCaseTagsProps) => {
  return (
    <HStack gap={1.5}>
      {(useCase === "contractor" || useCase === "both") && (
        <BusinessEntityUseCaseTag
          type={useCase}
          variant="contractor"
          tagsWidth={tagsWidth}
        />
      )}
      {(useCase === "client" || useCase === "both") && (
        <BusinessEntityUseCaseTag
          type={useCase}
          variant="client"
          tagsWidth={tagsWidth}
        />
      )}
    </HStack>
  );
};

export default BusinessEntityUseCaseTags;
